import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useMatch } from 'react-router-dom';
import moment from 'moment';
import {
  Button, Col, message, Modal, Row, Spin, Collapse, Divider,
  Tabs, Typography, Form, Upload, List, Checkbox, Input, notification,
  Tooltip, Card,
} from 'antd';
import {
  LoadingOutlined, DownloadOutlined, EditOutlined,
  DeleteOutlined, ExclamationCircleOutlined, PlusOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import {
  get, post, put, del,
  RequestWrapper, ResponseWrapper, isSuperAgentError,
} from '../../../dataSource/requests';
import './ServiceDetail.scss';
import SelectedLands from '../serviceComponents/selectedLands/SelectedLands';
import { getUserType, getUserPermissions } from '../../../utils/users';
import ServiceStatusComponent from '../../sharedComponents/serviceStatusComponent/ServiceStatusComponent';
import UploadFiles from '../serviceComponents/uploadFiles/UploadFiles';
import { downloadFile } from '../../../utils/helpers';
import { SessionExpiredException } from '../../../utils/errors';
import AreaTalhao from '../../sharedComponents/talhao/AreaTalhao';
import { formatTelephone } from '../../../utils/format';
import { isRestructuredService, depthReferenceIdCodeList } from '../../../utils/constants';
import imgPdf from '../../../assets/images/icon-pdf.svg';
import imgZip from '../../../assets/images/icon-zip.svg';
import imgKml from '../../../assets/images/icon-kml.png';
import imgKmz from '../../../assets/images/icon-kmz.png';
import imgDocx from '../../../assets/images/icon-docx.png';
import { backendResponseCodes } from '../../../utils/responseMessages';

const ServiceDetail = (): JSX.Element => {
  const navigate = useNavigate();
  const routeMatch = useMatch('/service/detail/:id');
  const [userType] = useState<string | null>(getUserType());
  const [isRestructured, setIsRestructured] = useState<boolean>(false);
  const getFormattedscheduleDate = (date): string => (date ? moment.utc(date).format('DD/MM/YYYY') : '');
  const [listImportResult, setListImportResult] = useState([]);
  const { confirm } = Modal;

  const [data, setData] = useState({
    attachments: [],
    shapefiles: [],
    kml: [],
    kmz: [],
    landFields: [],
    serviceTypeDynamicFields: [],
    serviceSubtypeDynamicFields: [],
    serviceRequestNotes: [],
    technicalDateAllocated: '',
  });

  const [memoryFileAttachmentId, setMemoryFileAttachmentId] = useState<number>(0);
  const [budgetData, setBudgetData] = useState({});
  const [attachmentSizeCooperated, setAttachmentSizeCooperated] = useState<string|number>('0');
  const [loading, setLoading] = useState<boolean>(false);
  const { Panel } = Collapse;
  const currencyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const [
    loadingDownloadAllServiceRequestFiles,
    setLoadingDownloadAllServiceRequestFiles,
  ] = useState<boolean>(false);

  const [
    loadingDownloadAllShapeFiles,
    setloadingDownloadAllShapeFiles,
  ] = useState<boolean>(false);
  const [
    loadingDownloadAllKMLFiles,
    setloadingDownloadAllKMLFiles,
  ] = useState<boolean>(false);
  const [
    loadingDownloadAllKMZFiles,
    setloadingDownloadAllKMZFiles,
  ] = useState<boolean>(false);

  const [statusesList, setStatusesList] = useState([]);
  const [currentStatusIndex, setCurrentStatusIndex] = useState<number>(0);
  const [canceled, setCanceled] = useState<boolean>(false);
  const [visibleModalStatus, setVisibleModalStatus] = useState<boolean>(false);
  const uploadFilesReference = useRef(null);

  const [importResultFormInstance] = Form.useForm();
  const [importResultModalFormInstance] = Form.useForm();
  const [visibleModalImportResult, setVisibleModalImportResult] = useState<boolean>(false);
  const [selectedReferenceFields, setSelectedReferenceFields] = useState([]);
  const [uploadFileLoading, setUploadFileLoading] = useState<boolean>(false);
  const [associateFileLoading, setAssociateFileLoading] = useState<boolean>(false);
  const [requestNewInstance, setRequestNewInstance] = useState<boolean>(false);
  const [arrLandsName, setArrLandsName] = useState([]);
  const [invertArrLandsFiles, setInvertArrLandsFiles] = useState([]);

  const getIconByName = (namee) => {
    switch (namee) {
      case 'pdf':
        return imgPdf;

      case 'kml':
        return imgKml;

      case 'kmz':
        return imgKmz;

      case 'zip':
        return imgZip;

      case 'docx':
        return imgDocx;

      case 'doc':
        return imgDocx;

      default:
        return imgZip;
    }
  };

  const downloadFileLocal = async (v, _url, name): Promise<void> => {
    let url = `/file/downloadFile/${v?.id}`;

    if (getUserType() === 'COOPERATIVE') {
      url = `/file/customer/downloadFile/${v?.id}`;
    }

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const requestRef: RequestWrapper = get({
        url: `${_url || url}`,

        responseType: 'blob',

        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await requestRef;
    } catch (error) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    switch (true) {
      case (response?.statusCode === 200): {
        let alternateFilename;

        if (name != null) {
          alternateFilename = `${name}.zip`;
        } else {
          alternateFilename = 'Todos os arquivos.zip';
        }

        downloadFile(
          response?.body,
          v?.name != null
            ? v?.name : (alternateFilename),
        );
      } break;

      case (responseError?.body.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (responseError?.body.code === -4003):
        // "You do not have permission to perform this operation", -4003
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error.General
            .Forbidden.description.pt_br,
        });
        break;

      case (responseError?.body.code === -9002):
        // "File not found", -9002
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error.File
            .FileNotFound.description.pt_br,
        });
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      case (responseError?.body.code === -4000):
      default:
        notification.error({
          message: 'Erro',
          description: 'Desculpe, houve um erro ao baixar o anexo, por favor '
            + 'tente novamente mais tarde.',
        });
        break;
    }
  };

  /**
   * @name listFilesImportResult
   * @description busca uma lista com as importações de resultados
   * @returns retorna uma lista com as importações de resultados
   */
  const listFilesImportResult = async (): Promise<void> => {
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const requestRef: RequestWrapper = get({
        url: `/file/listAllFileImportResult/${routeMatch.params.id}`,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await requestRef;
    } catch (error) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    let namesLandFields;
    response?.body.fileAttachments.map((itemFileAttach) => {
      namesLandFields = '';

      itemFileAttach.landsFields.map((i) => {
        namesLandFields += `${i.name},`;
      });

      itemFileAttach.namesLandFields = namesLandFields.substring(0, namesLandFields.length - 1);
    });

    setListImportResult(response?.body.fileAttachments);

    // invert array (lands > files)
    let invertArrLocalLandsFiles = [];
    response?.body.fileAttachments.map((i) => {
      i.landsFields.map((target) => {
        invertArrLocalLandsFiles.push(target);
        invertArrLocalLandsFiles.fields = [];
      });
    });

    // remove duplicidade
    invertArrLocalLandsFiles = invertArrLocalLandsFiles.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    // mapeamento para inverção (land > file)
    let targetFilesAvailable = [];
    invertArrLocalLandsFiles.forEach((itemLand) => {
      response?.body.fileAttachments.forEach((itemFile) => {
        itemFile.landsFields.forEach((itemLandFile) => {
          if (itemLand.id === itemLandFile.id) {
            targetFilesAvailable.push(itemFile);
          }
        });
      });

      itemLand.filesAvailable = targetFilesAvailable;
      targetFilesAvailable = [];
    });

    setInvertArrLandsFiles(invertArrLocalLandsFiles);
  };

  /**
   * @name handleDownloadFileImportResult
   * @param {*} id
   * @param {*} name
   * @description busca um arquivo da importação de resultados para download
   * @returns retorna um arquivo da importação de resultados para download
   */
  const handleDownloadFileImportResult = async (id, name): Promise<void> => {
    let file;
    const url = `/file/downloadFile/${id}`;

    try {
      const requestRef: RequestWrapper = get({
        url,

        frontConfigs: {
          navigateFunction: navigate,
        },

        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },

        responseType: 'blob',
      });

      file = await requestRef;
    } catch (error) {
      notification.error({
        message: 'Erro',
        description: 'Não foi possivel fazer o download do arquivo.',
      });

      return;
    }

    if (file.status === 200) {
      const filee = new Blob([file.body], { type: 'application/pdf' });
      const a = document.createElement('a');
      const newUrl = window.URL.createObjectURL(filee);

      a.href = newUrl;
      a.download = !name ? 'resultado-importado' : name;
      document.body.append(a);
      a.click();

      setTimeout(() => {
        a.remove();
        window.URL.revokeObjectURL(newUrl);
      }, 0);
    } else {
      notification.error({
        message: 'Erro',
        description: 'Documento não encontrado.',
      });
    }
  };

  /**
   * @name handleDeleteFileImportResult
   * @param {*} fileId
   * @description chama uma requisição para remover um arquivo da importação de resultados
   * @return remove um arquivo da importação de resultados
   */
  const handleDeleteFileImportResult = async (fileId): Promise<void> => {
    try {
      const url = `/file/deleteFileImportResult/${fileId}`;

      const requestRef: RequestWrapper = del({
        url,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      const responseImportResult = await requestRef;

      if (responseImportResult?.body.error) {
        notification.error({
          message: 'Erro',
          description: 'Não foi possivel excluir o arquivo.',
        });

        setLoading(false);
      } else {
        listFilesImportResult();

        notification.success({
          message: 'Sucesso',
          description: 'O arquivo foi excluído com sucesso.',
        });

        setLoading(false);
      }
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        notification.error({
          message: 'Erro',
          description: 'Não foi possivel excluir o arquivo.',
        });

        setLoading(false);
      }
    }
  };

  /**
   * @name confirmDeleteFileImportResult
   * @param {*} fileId
   * @description confirmação de exclusão de registro da lista de importação de resultados
   * @returns retorna uma modal em página para o usuário confirmar a exclusão do registro da lista
   */
  const confirmDeleteFileImportResult = (fileId): void => {
    confirm({
      title: 'O anexo será excluído!',
      icon: <ExclamationCircleOutlined />,
      content: 'Tem certeza que deseja excluir?',
      okText: 'Sim',
      okType: 'danger',
      cancelText: 'Não',

      onOk() {
        handleDeleteFileImportResult(fileId);
      },

      onCancel() {
        console.log('Cancel');
      },
    });
  };

  /**
   * @name handleUpdateFileImportResult
   * @param {*} id
   * @param {*} indice
   * @description fluxo para exibir informações para edição de uma importação de resultado
   * dentro da modal
   * @returns exibe a modal com as informações carregadas para edição
   * de uma importação de resultados onde somente talhões e observações podem ser alterados
   */
  const handleUpdateFileImportResult = (id, indice): void => {
    setMemoryFileAttachmentId(id);

    // sinalizador de nova requisição ou alteração de requisição existente
    setRequestNewInstance(false);

    // estado preparado para encontrar os talhões que precisam ser editados
    setArrLandsName(listImportResult[indice].landsFields);

    listImportResult[indice].landsFields.map((item) => {
      setSelectedReferenceFields((previous) => {
        return [
          ...previous,
          item.id,
        ];
      });
    });

    importResultModalFormInstance.setFieldsValue({
      comments: listImportResult[indice].note
    });
    setVisibleModalImportResult(true);
  };

  useEffect(() => {
    const getSystemParameters = async (): Promise<void> => {
      setLoading(true);

      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      try {
        const requestRef: RequestWrapper = get({
          url: '/system/getAttachmentParamenters',

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await requestRef;
      } catch (error) {
        if (!(error instanceof SessionExpiredException)) {
          setLoading(false, '');
          return;
        }

        setLoading(false, '');
        return;
      }

      if (response?.body.error) {
        setLoading(false);
      }

      setAttachmentSizeCooperated(
        response?.body.getAttachmentParamentersOutput.attachmentSizeCooperated,
      );

      setLoading(false);
    };

    getSystemParameters();
    listFilesImportResult();

    return () => {
      setLoading(false);
    };
  }, []);

  const downloadAllFiles = async (file, nameFile): Promise<void> => {
    let response;

    const url = userType === 'COOPERATIVE'
      ? '/file/customer/downloadAllServiceRequestFiles/'
      : '/file/downloadAllServiceRequestFiles/';

    try {
      const requestRef: RequestWrapper = get({
        url: `${url}${routeMatch.params.id}`,

        frontConfigs: {
          navigateFunction: navigate,
        },

        responseType: 'blob',

        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },
      });

      response = await requestRef;
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        message.error('Ocorreu um erro ao baixar os Anexos, tente novamente');
      }
      return;
    }

    if (nameFile != undefined) {
      downloadFile(response?.body, `${nameFile}-${routeMatch.params.id}.zip`);
    } else {
      downloadFile(response?.body, `anexos-cooperado-${routeMatch.params.id}.zip`);
    }
  };

  const downloadAllServiceRequestFiles = async (): Promise<void> => {
    let response;

    setLoadingDownloadAllServiceRequestFiles(true);

    let url = '/file/downloadAllServiceRequestFiles/';

    if (userType === 'COOPERATIVE') {
      url = '/file/customer/downloadAllServiceRequestFiles/';
    }

    try {
      const requestRef: RequestWrapper = get({
        url: `${url}${routeMatch.params.id}`,

        frontConfigs: {
          navigateFunction: navigate,
        },

        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },

        responseType: 'blob',
      });

      response = await requestRef;
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        message.error('Ocorreu um erro ao baixar os anexos, tente novamente');
      }

      setLoadingDownloadAllServiceRequestFiles(false);
      return;
    }

    downloadFile(response?.body, `anexos-${routeMatch.params.id}.zip`);
    setLoadingDownloadAllServiceRequestFiles(false);
  };

  const downloadAllShapefiles = async (): Promise<void> => {
    setloadingDownloadAllShapeFiles(true);

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    const url = '/file/downloadAllServiceRequestShapefiles/';

    try {
      const requestRef: RequestWrapper = get({
        url: `${url}${routeMatch.params.id}`,

        frontConfigs: {
          navigateFunction: navigate,
        },

        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },

        responseType: 'blob',
      });

      response = await requestRef;
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        message.error('Ocorreu um erro ao baixar os shapefiles, tente novamente');
      }

      setloadingDownloadAllShapeFiles(false);
      return;
    }

    downloadFile(response?.body, `anexos-${routeMatch.params.id}.zip`);
    setloadingDownloadAllShapeFiles(false);
  };

  const downloadAllKML = async (): Promise<void> => {
    setloadingDownloadAllKMLFiles(true);

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    const url = '/file/downloadAllServiceRequestKml/';

    try {
      const requestRef: RequestWrapper = get({
        url: `${url}${routeMatch.params.id}`,

        frontConfigs: {
          navigateFunction: navigate,
        },

        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },

        responseType: 'blob',
      });

      response = await requestRef;
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        message.error('Ocorreu um erro ao baixar os arquivos KML, tente novamente');
      }

      setloadingDownloadAllKMLFiles(false);
      return;
    }

    downloadFile(response?.body, `anexos-${routeMatch.params.id}.zip`);
    setloadingDownloadAllKMLFiles(false);
  };

  const downloadAllKMZ = async (): Promise<void> => {
    setloadingDownloadAllKMZFiles(true);

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    const url = '/file/downloadAllServiceRequestKmz/';

    try {
      const requestRef: RequestWrapper = get({
        url: `${url}${routeMatch.params.id}`,

        frontConfigs: {
          navigateFunction: navigate,
        },

        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },

        responseType: 'blob',
      });

      response = await requestRef;
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        message.error('Ocorreu um erro ao baixar os arquivos KMZ, tente novamente');
      }

      setloadingDownloadAllKMZFiles(false);
      return;
    }

    downloadFile(response?.body, `anexos-${routeMatch.params.id}.zip`);
    setloadingDownloadAllKMZFiles(false);
  };

  const getField = (idCodeParameter) => {
    return data
      .serviceRequestFields
      .find(
        (field) => {
          return field.idCode === idCodeParameter;
        },
      );
  };

  const handleValue = (fieldValue) => {
    switch (true) {
      case (fieldValue === true):
      case (fieldValue === 'true'):
        return 'Sim';

      case (fieldValue === false):
      case (fieldValue === 'false'):
        return 'Não';

      case (fieldValue?._isAMomentObject):
        return fieldValue.format('DD/MM/YYYY');

      case (/[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}Z/.test(fieldValue)):
        return moment(fieldValue, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]').format('DD/MM/YYYY');

      default:
        return fieldValue;
    }
  };

  const printField = (idCodeParameter): JSX.Element | null => {
    const field = getField(idCodeParameter);

    if (field !== undefined) {
      let fieldName = field.name;

      if (field.name === 'Profundidade') {
        depthReferenceIdCodeList.map((f) => {
          if (f.idCode === idCodeParameter) {
            fieldName = f.value;
          }
        });
      }

      if (field.name === 'Tamanho do grid (em hectares)' && field.value === 'Outro') {
        field.name = 'Tamanho do grid';
      }

      if (field.name === 'Tamanho desejado') {
        field.name += ' (em hectares)';
      }

      if (field.value !== null) {
        return (
          <Row className="param-row" key={field.idCode}>
            <Col span={24}>
              {field.name == 'Profundidade' ? <hr /> : null}
              <Row justify="space-between">
                <Col>{`${fieldName}:`}</Col>
                <Col><b>{handleValue(field.value)}</b></Col>
              </Row>
            </Col>
          </Row>
        );
      }
    }

    return null;
  };

  const renderGeofertGridFields = (): JSX.Element => {
    return (
      <>
        {printField('GEOFERT-GRID-TAMANHO_GRID')}
        {printField('GEOFERT-GRID-GRID_TAMANHO_DESEJADO')}
        {printField('GEOFERT-GRID-V_DESEJADO')}
        {printField('GEOFERT-GRID-PRNT_CALCARIO')}
        {printField('GEOFERT-GRID-PRNT_OXIDO')}
        {printField('GEOFERT-GRID-QUANTAS_PROFUNDIDADES')}

        {printField('GEOFERT-GRID-PROFUNDIDADE_1')}

        {printField('GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_1')}
        {printField('GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_1_ROTINA_ALUMINIO_ENXOFRE')}
        {printField('GEOFERT-GRID-MICRO_PROFUNDIDADE_1')}
        {printField('GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_1_MICRO')}
        {printField('GEOFERT-GRID-FISICA_PROFUNDIDADE_1')}
        {printField('GEOFERT-GRID-PROPORCAO_PRODUNDIDADE_1_FISICA')}

        {printField('GEOFERT-GRID-PROFUNDIDADE_2')}

        {printField('GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_2')}
        {printField('GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_2_ROTINA_ALUMINIO_ENXOFRE')}
        {printField('GEOFERT-GRID-MICRO_PROFUNDIDADE_2')}
        {printField('GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_2_MICRO')}
        {printField('GEOFERT-GRID-FISICA_PROFUNDIDADE_2')}
        {printField('GEOFERT-GRID-PROPORCAO_PRODUNDIDADE_2_FISICA')}

        {printField('GEOFERT-GRID-PROFUNDIDADE_3')}

        {printField('GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_3')}
        {printField('GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_3_ROTINA_ALUMINIO_ENXOFRE')}
        {printField('GEOFERT-GRID-MICRO_PROFUNDIDADE_3')}
        {printField('GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_3_MICRO')}
        {printField('GEOFERT-GRID-FISICA_PROFUNDIDADE_3')}
        {printField('GEOFERT-GRID-PROPORCAO_PRODUNDIDADE_3_FISICA')}

        {printField('GEOFERT-GRID-PROFUNDIDADE_4')}

        {printField('GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_4')}
        {printField('GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_4_ROTINA_ALUMINIO_ENXOFRE')}
        {printField('GEOFERT-GRID-MICRO_PROFUNDIDADE_4')}
        {printField('GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_4_MICRO')}
        {printField('GEOFERT-GRID-FISICA_PROFUNDIDADE_4')}
        {printField('GEOFERT-GRID-PROPORCAO_PRODUNDIDADE_4_FISICA')}

        {printField('GEOFERT-GRID-PROFUNDIDADE_5')}

        {printField('GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_5')}
        {printField('GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_5_ROTINA_ALUMINIO_ENXOFRE')}
        {printField('GEOFERT-GRID-MICRO_PROFUNDIDADE_5')}
        {printField('GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_5_MICRO')}
        {printField('GEOFERT-GRID-FISICA_PROFUNDIDADE_5')}
        {printField('GEOFERT-GRID-PROPORCAO_PRODUNDIDADE_5_FISICA')}
      </>
    );
  };

  const renderGeofertZonaDeManejoSateliteFields = (): JSX.Element => {
    return (
      <>
        {printField('GEOFERT-ZONA_MANEJO-SATELITE-V_DESEJADO')}
        {printField('GEOFERT-ZONA_MANEJO-SATELITE-PRNT_CALCARIO')}
        {printField('GEOFERT-ZONA_MANEJO-SATELITE-PRNT_OXIDO')}
        {printField('GEOFERT-ZONA_MANEJO-VARIEDADE')}
        {printField('GEOFERT-ZONA_MANEJO-ESTAGIO_CORTE')}
        {printField('GEOFERT-ZONA_MANEJO-DATA_ULTIMO_CORTE')}
        {printField('GEOFERT-ZONA_MANEJO-DATA_PENULTIMO_CORTE')}
        {printField('GEOFERT-ZONA_MANEJO-DATA_PLANTIO')}
        {printField('GEOFERT-ZONA_MANEJO-HOUVE_TOMBAMENTO')}
        {printField('GEOFERT-ZONA_MANEJO-DATA_TOMBAMENTO')}
        {printField('GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR')}
        {printField('GEOFERT-ZONA_MANEJO-DATA_APLICACAO_MATURADOR')}
        {printField('GEOFERT-ZONA_MANEJO-NOME_PRODUTO_UTILIZADO_APLICACAO_MATURADOR')}
      </>
    );
  };

  const renderGeofertZonaDeManejoCondEletFields = (): JSX.Element => {
    return (
      <>
        {printField('GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-V_DESEJADO')}
        {printField('GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-PRNT_CALCARIO')}
        {printField('GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-PRNT_OXIDO')}
      </>
    );
  };

  const renderGeofertZDMVantFields = (): JSX.Element => {
    return (
      <>
        {printField('GEOFERT-ZONA_MANEJO-VANT-V_DESEJADO')}
        {printField('GEOFERT-ZONA_MANEJO-VANT-PRNT_CALCARIO')}
        {printField('GEOFERT-ZONA_MANEJO-VANT-PRNT_OXIDO')}
        {printField('GEOFERT-ZONA_MANEJO-VARIEDADE')}
        {printField('GEOFERT-ZONA_MANEJO-ESTAGIO_CORTE')}
        {printField('GEOFERT-ZONA_MANEJO-DATA_ULTIMO_CORTE')}
        {printField('GEOFERT-ZONA_MANEJO-DATA_PENULTIMO_CORTE')}
        {printField('GEOFERT-ZONA_MANEJO-DATA_PLANTIO')}
        {printField('GEOFERT-ZONA_MANEJO-HOUVE_TOMBAMENTO')}
        {printField('GEOFERT-ZONA_MANEJO-DATA_TOMBAMENTO')}
        {printField('GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR')}
        {printField('GEOFERT-ZONA_MANEJO-DATA_APLICACAO_MATURADOR')}
        {printField('GEOFERT-ZONA_MANEJO-NOME_PRODUTO_UTILIZADO_APLICACAO_MATURADOR')}
      </>
    );
  };

  const renderPosVendasAssistenciaTecnicaFields = (): JSX.Element => {
    return (
      <>
        {printField('POS_VENDA_ASSISTENCIA_TECNICA_MUNICIPIO')}
        {printField('POS_VENDA_ASSISTENCIA_TECNICA_MODELO')}
        {printField('POS_VENDA_ASSISTENCIA_TECNICA_MOTIVO_SOLICITACAO')}
        {printField('POS_VENDA_ASSISTENCIA_TECNICA_TIPO_ORDEM')}
      </>
    );
  };

  const renderPosVendasLocacaoPilotoFields = (): JSX.Element => {
    return (
      <>
        {printField('POS_VENDA_LOCACAO_DE_PILOTO_MUNICIPIO')}
        {printField('POS_VENDA_LOCACAO_DE_PILOTO_MODELO')}
        {printField('POS_VENDA_LOCACAO_DE_PILOTO_PERIODO_DESEJADO')}
        {printField('POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_INICIO')}
        {printField('POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_FIM')}
        {printField('POS_VENDA_LOCACAO_DE_PILOTO_TIPO_ORDEM')}
      </>
    );
  };

  const renderPosVendasMontagemEquipamentoFields = (): JSX.Element => {
    return (
      <>
        {printField('POS_VENDA_MONTAGEM_DE_EQUIPAMENTO_TIPO_ORDEM')}
      </>
    );
  };

  const renderRestructuredServiceFields = (): JSX.Element | null => {
    switch (true) {
      case (data?.serviceName?.toUpperCase() === 'GEOFERT' && data?.serviceTypeName?.toUpperCase() === 'GRID'):
        return renderGeofertGridFields();

      case (data?.serviceName?.toUpperCase() === 'GEOFERT' && data?.serviceTypeName?.toUpperCase() === 'ZONA DE MANEJO' && data?.serviceSubtypeName?.toUpperCase() === 'SATÉLITE'):
        return renderGeofertZonaDeManejoSateliteFields();

      case (data?.serviceName?.toUpperCase() === 'GEOFERT' && data?.serviceTypeName?.toUpperCase() === 'ZONA DE MANEJO' && data?.serviceSubtypeName?.toUpperCase() === 'CONDUTIVIDADE ELÉTRICA'):
        return renderGeofertZonaDeManejoCondEletFields();

      case (data?.serviceName?.toUpperCase() === 'GEOFERT' && data?.serviceTypeName?.toUpperCase() === 'ZONA DE MANEJO' && data?.serviceSubtypeName?.toUpperCase() === 'VANT'):
        return renderGeofertZDMVantFields();

      case (data?.serviceName?.toUpperCase() === 'PÓS-VENDAS' && data?.serviceTypeName?.toUpperCase() === 'ASSISTÊNCIA TÉCNICA'):
        return renderPosVendasAssistenciaTecnicaFields();

      case (data?.serviceName?.toUpperCase() === 'PÓS-VENDAS' && data?.serviceTypeName?.toUpperCase() === 'LOCAÇÃO DE PILOTO'):
        return renderPosVendasLocacaoPilotoFields();

      case (data?.serviceName?.toUpperCase() === 'PÓS-VENDAS' && data?.serviceTypeName?.toUpperCase() === 'MONTAGEM DE EQUIPAMENTO'):
        return renderPosVendasMontagemEquipamentoFields();

      default:
        return null;
    }
  };

  const renderEstimateDetailFields = (): JSX.Element => {
    return (
      <div>

        <Row>
          <Col xs={{ span: 12 }} lg={{ span: 12 }}>
            <p className="item-title">Orçamento: </p>
          </Col>
        </Row>
        <Row justify="space-between" className="param-row">
          <Col>Valor unitário:</Col>
          <Col><b>{`${currencyFormatter.format(budgetData.unitaryValue ?? '0')}`}</b></Col>
        </Row>
        <Row justify="space-between" className="param-row">
          <Col>Valor total:</Col>
          <Col><b>{`${currencyFormatter.format(budgetData.amount ?? '0')}`}</b></Col>
        </Row>
        <Row justify="space-between" className="param-row">
          <Col>Condição de pagamento:</Col>
          <Col><b>{budgetData.paymentTerms}</b></Col>
        </Row>
        <Row justify="space-between" className="param-row">
          <Col>Forma de pagamento:</Col>
          <Col><b>{budgetData.formOfPayment}</b></Col>
        </Row>
        <Row className="param-row">
          <p className="item-title">Observação:</p>
        </Row>
        <Row gutter={24} className="inline-field param-row">
          <Col span={24}>
            <Col className="observacaoCol">{budgetData.budgetNotes ?? '-'}</Col>
          </Col>
        </Row>

        <Row className="param-row">
          <p className="item-title">Responsável pelo orçamento:</p>
        </Row>
        <Row gutter={24} className="inline-field param-row">
          <Col span={24}>
            <Col className="observacaoCol">
              {
                !budgetData.responsableBudget
                  ? '-'
                  : budgetData.responsableBudget
              }
            </Col>
          </Col>
        </Row>

        <Row className="param-row">
          <p className="item-title">
            Data/hora da aprovação:
          </p>
        </Row>
        <Row gutter={24} className="inline-field param-row">
          <Col span={24}>
            <Col className="observacaoCol">{moment(budgetData.approveOrRecuseDate).format('DD/MM/YYYY [às] HH:mm')}</Col>
          </Col>
        </Row>
        <Divider type="horizontal" />
      </div>
    );
  };

  const renderDynamicFieldSummary = (field, key): JSX.Element | null => {
    if (field.value == '01/01/1900') {
      return null;
    }

    return (
      <Row className="param-row" key={key}>
        <Col span={24}>
          <Row justify="space-between">
            <Col>{`${field.name}:`}</Col>
            <Col><b>{field.value}</b></Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const renderGridFields = (field, index, list): JSX.Element | null => {
    if (field.name === 'Proporção') {
      return null;
    }

    if (index === 0) {
      return (
        <div key="subtype-0">
          <Row className="param-row">
            <Col span={24}>
              <Row justify="space-between">
                <Col>Tamanho do grid:</Col>
                <Col><b>{`${field.value} hectares`}</b></Col>
              </Row>
            </Col>
          </Row>
          <Row className="param-row">Amostragem da camada 0-20cm:</Row>
        </div>
      );
    }
    return (
      <div key={`subtype-${index}`}>
        {
          field.name === 'Rotina, Alumínio e Enxofre'
          && index !== 1
          && (
            <Row className="param-row">Amostragem da camada 20-40cm:</Row>
          )
        }
        {
          field.value === 'Sim'
            ? (
              <div>
                <Row className="section-row">
                  <Col xs={{ offset: 0, span: 24 }} lg={{ offset: 1, span: 23 }}>
                    <Row justify="space-between">
                      <Col>{field.name}</Col>
                      <Col><b>{`Proporção ${list[index + 1].value}`}</b></Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            )
            : (
              <div>
                <Row className="section-row">
                  <Col className="title" xs={{ offset: 0, span: 24 }} lg={{ offset: 1, span: 23 }}>
                    <Row justify="space-between">
                      <Col>{field.name}</Col>
                      <Col><b>Não solicitada</b></Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            )
        }
      </div>
    );
  };

  const conditionallyRenderGridAndSubtypeFields = (): (JSX.Element | null)[] | null => {
    if (!isRestructured) {
      if (data.serviceTypeName !== 'Grid') {
        return data.serviceSubtypeDynamicFields
          .filter((f) => f.name !== 'Valor unitário'
            && f.name !== 'Valor total'
            && f.name !== 'Condição de pagamento'
            && f.name !== 'Forma de pagamento'
            && f.name !== 'Observações do orçamento',
          ).map(
            (value, index) => renderDynamicFieldSummary(value, `subtype-${index}`),
          );
      }

      return data.serviceSubtypeDynamicFields.map(renderGridFields);
    }

    return null;
  };

  const getBudgetData = async (id): Promise<void> => {
    let url = '/budget/customer/findBudgetRequestDetails';

    if (userType === 'COOPERCITRUS') {
      url = '/budget/coopercitrus/findBudgetRequestDetails';
    }

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const requestRef: RequestWrapper = get({
        url: `${url}/${+id}`,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await requestRef;
    } catch (error) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
      if (!(error instanceof SessionExpiredException)) {
        message.error('Ocorreu um erro ao buscar os detalhes, tente novamente');
      }
      return;
    }

    if (!response?.body.error) {
      setBudgetData(response?.body.details);
    } else {
      message.error('Ocorreu um erro ao buscar os orçamentos, tente novamente');
    }
  };

  const loadData = async (id): Promise<void> => {
    setLoading(true);

    let url = '/service/customer/findServiceRequestDetails';

    if (userType === 'COOPERCITRUS') {
      url = '/service/coopercitrus/findServiceRequestDetails';
    }

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const requestRef: RequestWrapper = get({
        url: `${url}/${id}`,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await requestRef;
    } catch (error) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }

      if (!(error instanceof SessionExpiredException)) {
        message.error('Ocorreu um erro ao buscar os detalhes, tente novamente');
      }

      setLoading(false);
      return;
    }

    if (!response?.body.error) {
      setData(response?.body.details);
      const serviceFullName = `${response?.body.details.serviceName} ${(response?.body.details?.serviceTypeName) ? response?.body.details?.serviceTypeName : ''} ${(response?.body.details?.serviceSubtypeName) ? response?.body.details?.serviceSubtypeName : ''}`;
      if (response?.body.details.budgetId != undefined) {
        await getBudgetData(response?.body.details.budgetId);
      }
      setIsRestructured(isRestructuredService(serviceFullName));
      setLoading(false);
    } else {
      setLoading(false);
      message.error('Ocorreu um erro ao buscar os detalhes, tente novamente');
    }
  };

  const uploadAtFiles = async (): Promise<void> => {
    const uploadError = !uploadFilesReference.current.validateFiles();

    setLoading(true);

    if (!uploadError) {
      try {
        await uploadFilesReference.current.handleSubmitFiles();
      } catch (error) {
        setLoading(false);
        return;
      }
    }
    loadData(routeMatch.params.id);
    setLoading(false);
  };

  useEffect(() => {
    const loadStatusData = async (id): Promise<void> => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      try {
        const requestRef: RequestWrapper = get({
          url: `/service/getServiceStatusFlow/${id}`,

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await requestRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }

        if (!(error instanceof SessionExpiredException)) {
          message.error('Ocorreu um erro ao buscar o fluxo de status, tente novamente');
        }

        return;
      }

      if (!response?.body.error) {
        const newStatusesList = response?.body.serviceStatusFlowOutputs;
        setStatusesList(newStatusesList);
        const findLastIndex = (array): number => {
          let finalIndex = 0;

          for (const ind in array) {
            if (array[ind].date != null) {
              finalIndex = ind;
            }
          }

          return finalIndex;
        };
        const statIndex = findLastIndex(newStatusesList);
        setCurrentStatusIndex(Number.parseInt(statIndex, 10));
        setCanceled(!!newStatusesList.find((v) => v.reasonForCancellation));
      } else {
        message.error('Ocorreu um erro ao buscar o fluxo de status, tente novamente');
      }
    };

    loadData(routeMatch.params.id);
    loadStatusData(routeMatch.params.id);
  }, []);

  const addReferenceLandField = (landFieldId): void => {
    const found = selectedReferenceFields.find((element) => {
      return element === landFieldId;
    });

    if (found) {
      return;
    }

    setSelectedReferenceFields((previous) => {
      return [
        ...previous,
        landFieldId,
      ];
    });
  };

  const removeReferenceLandField = (landFieldId): void => {
    const found = selectedReferenceFields.find((element) => {
      return element === landFieldId;
    });

    if (!found) {
      return;
    }

    setSelectedReferenceFields((previous) => {
      return [
        ...previous.filter((element) => {
          return element !== landFieldId;
        }),
      ];
    });
  };

  const resetSelectedReferenceLandField = (): void => {
    setSelectedReferenceFields([]);
  };

  const handleChangeReferenceLandField = (eventt): void => {
    if (eventt.target.checked === true) {
      addReferenceLandField(eventt.target.value);
    } else {
      removeReferenceLandField(eventt.target.value);
    }
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const handleAssociateLandFieldsResponse = (response, responseError): void => {
    switch (true) {
      case (response?.body?.code === 9014):
        notification.success({
          message: 'Sucesso',
          description: 'O arquivo de resultados foi cadastrado.',
        });

        listFilesImportResult();
        resetSelectedReferenceLandField();
        importResultFormInstance.resetFields();
        importResultModalFormInstance.resetFields();
        setVisibleModalImportResult(false);
        break;

      case (responseError?.code === -4003):
        notification.warning({
          message: 'Atenção',
          description: 'Desculpe, você não possui permissão para realizar esta ação.',
        });

        resetSelectedReferenceLandField();
        importResultFormInstance.resetFields();
        importResultModalFormInstance.resetFields();
        setVisibleModalImportResult(false);
        break;

      case (response?.error):
      case (response?.body?.error):
      default:
        notification.error({
          message: 'Erro',
          description: 'Desculpe, houve um problema ao vincular o arquivo e os talhões, tente novamente mais tarde por favor.',
        });

        resetSelectedReferenceLandField();
        importResultFormInstance.resetFields();
        importResultModalFormInstance.resetFields();
        setVisibleModalImportResult(false);
        break;
    }
  };

  const handleUploadFileResponse = async (values, responseUploadFile, responseUploadFileError): Promise<void> => {
    let responseAssociateLandFields;
    let responseAssociateLandFieldsError;

    switch (true) {
      case (responseUploadFile?.body?.code === 9014):
        try {
          setAssociateFileLoading(true);

          const requestRef: RequestWrapper = post({
            url: '/file/nodeAndLandFieldsRequest',

            params: {
              fileAttachmentId: responseUploadFile
                .body
                .uploadAllFilesServiceRequestOutput
                .fileAttachmentId,
              landFieldId: selectedReferenceFields,
              note: values.comments,
            },

            headers: {
              Accept: 'application/json',
            },

            frontConfigs: {
              navigateFunction: navigate,
            },
          });

          responseAssociateLandFields = await requestRef;
        } catch (error) {
          responseAssociateLandFieldsError = JSON.parse(error.message);
          console.log('error', error);
        } finally {
          setAssociateFileLoading(false);
        }

        handleAssociateLandFieldsResponse(
          responseAssociateLandFields,
          responseAssociateLandFieldsError,
        );
        break;

      case (responseUploadFileError?.code === -4003):
        notification.warning({
          message: 'Atenção',
          description: 'Desculpe, você não possui permissão para realizar esta ação.',
        });

        resetSelectedReferenceLandField();
        importResultFormInstance.resetFields();
        importResultModalFormInstance.resetFields();
        setVisibleModalImportResult(false);
        break;

      case (responseUploadFile?.error):
      case (responseUploadFile?.body?.error):
      default:
        notification.error({
          message: 'Erro',
          description: 'Desculpe, houve um problema ao realizar o upload do arquivo, tente novamente mais tarde por favor.',
        });

        resetSelectedReferenceLandField();
        importResultFormInstance.resetFields();
        importResultModalFormInstance.resetFields();
        setVisibleModalImportResult(false);
        break;
    }
  };

  const handleSuccessfulFormImportFile = async (values): Promise<void> => {
    if (requestNewInstance) {
      let responseUploadFile;
      let responseUploadFileError;
      const formData = new FormData();
      const fileValues = importResultFormInstance.getFieldsValue();

      fileValues?.resultFile?.forEach((fileElement) => {
        formData.append('newAttachment', fileElement.originFileObj);
        formData.append('id', routeMatch.params.id);
      });

      try {
        setUploadFileLoading(true);

        const requestRef: RequestWrapper = post({
          url: '/file/uploadAnyTypeServiceRequestFiles',

          params: formData,

          headers: {
            Accept: 'application/json',
          },

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        responseUploadFile = await requestRef;
      } catch (error) {
        console.log('error', error);
        responseUploadFileError = JSON.parse(error.message);
      } finally {
        setUploadFileLoading(false);
      }

      await handleUploadFileResponse(values, responseUploadFile, responseUploadFileError);
    } else {
      try {
        setAssociateFileLoading(true);

        const requestRef: RequestWrapper = put({
          url: '/file/editFileImportResult',

          params: {
            fileAttachmentId: memoryFileAttachmentId,
            landFields: selectedReferenceFields,
            note: values.comments,
          },

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        let responseEditImportFileResult = await requestRef;

        if (responseEditImportFileResult?.body) {
          notification.success({
            message: 'Sucesso',
            description: 'Importação atualizada com sucesso.',
          });

          listFilesImportResult();
          setVisibleModalImportResult(false);
          resetSelectedReferenceLandField();
        } else {
          notification.error({
            message: 'Erro',
            description: 'Desculpe, houve um problema ao atualizar a importação, tente novamente mais tarde por favor.',
          });
        }
      } catch (ex) {
        notification.error({
          message: 'Erro',
          description: 'Desculpe, houve um problema ao atualizar a importação, tente novamente mais tarde por favor.',
        });
      } finally {
        setAssociateFileLoading(false);
      }
    }
  };

  /**
* @name resolveLand
* @param {*} itemId
* @description identifica os talhões que estão relacionados com a importação de resultado
* que está sendo editada
* @returns retorna os talhões checados, relacionado a importação de resultado
* que está sendo editada
*/
  const resolveLand = (itemId): boolean => {
    let landChecked = false;
    const targetLand = arrLandsName.find((f) => {
      return f.id === itemId;
    });

    if (targetLand) {
      landChecked = true;
    }

    return landChecked;
  };

  return (
    <div className="ServiceDetail">
      <Spin
        tip="Carregando..."
        spinning={loading}
      >
        {
          userType === 'COOPERCITRUS'
            ? (
              <Row gutter={24}>
                <Col xs={{ span: 24 }} lg={{ span: 11 }}>
                  <span className="service-title">Detalhes da Solicitação</span>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 13 }}>
                  <div className="buttons-container">
                    <Row gutter={[24, 24]}>
                      <Col xs={{ span: 24 }} md={{ span: 8 }}>
                        <Button
                          className="btn-previous"
                          onClick={
                            (): void => {
                              navigate('/service/list');
                            }
                          }
                        >
                          Voltar
                        </Button>
                      </Col>

                      <Col xs={{ span: 24 }} md={{ span: 8 }}>
                        {
                          (data.status !== 'Cancelado')
                            ? (
                              <Button
                                className="btn-refresh"
                                type="primary"
                                onClick={
                                  (): void => {
                                    navigate(`/service/status/${routeMatch.params.id}`);
                                  }
                                }
                              >
                                Atualizar status
                              </Button>
                            )
                            : (
                              <Button
                                className="btn-refresh"
                                type="primary"
                                onClick={
                                  (): void => {
                                    setVisibleModalStatus(true);
                                  }
                                }
                              >
                                Ver status
                              </Button>
                            )
                        }
                      </Col>

                      <Col xs={{ span: 24 }} md={{ span: 8 }}>
                        <Button
                          href={`/service/edit/${routeMatch.params.id}`}
                          className="btn-edit"
                          type="primary"
                          onClick={
                            (eventt): void => {
                              eventt.preventDefault();
                              navigate(`/service/edit/${routeMatch.params.id}`);
                            }
                          }
                        >
                          Editar
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            )
            : (
              <Row gutter={24}>
                <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                  <span className="service-title">Detalhes</span>
                </Col>
                <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                  <div className="buttons-container">
                    <Button
                      href="/service/list"
                      className="btn-previous-cooperado"
                      onClick={
                        (eventt): void => {
                          eventt.preventDefault();
                          navigate('/service/list');
                        }
                      }
                    >
                      Voltar
                    </Button>
                  </div>
                </Col>
              </Row>
            )
        }

        <Tabs
          defaultActiveKey="1"
          className="ServiceDetail__Tabs"
        >
          <Tabs.TabPane
            tab={(
              <Typography.Title
                level={5}
                className="ServiceDetail__GeneralInfoTabTitle"
              >
                Informações gerais
              </Typography.Title>
            )}
            key="1"
          >
            <div className="inner-container">
              <Row gutter={24}>
                <Col xs={{ span: 24 }} lg={{ span: 11 }}>
                  <div>
                    {
                      data.budgetId
                        ? (
                          <Row gutter={24}>
                            <Col xs={24} lg={24}>
                              <a
                                href={`/service/estimates/${data.budgetId}/details`}
                              >
                                <p className="item-descripetion">
                                  {`Serviço criado referente ao orçamento aprovado: ${data.budgetId}`}
                                </p>
                              </a>
                            </Col>
                          </Row>
                        )
                        : null
                    }

                    {data.budgetId ? renderEstimateDetailFields() : null}
                    {
                      !data.budgetId && (
                        <div>
                          {(
                            (
                              data?.serviceRequestFields?.filter(
                                (f) => (f.name === 'Valor unitário'
                                  || f.name === 'Valor total'
                                  || f.name === 'Condição de pagamento'
                                  || f.name === 'Forma de pagamento'
                                  || f.name === 'Observações do orçamento'),
                              ).length > 0
                            ) || (
                              data.serviceTypeDynamicFields
                                .filter((f) => f.name === 'Valor unitário'
                                  || f.name === 'Valor total'
                                  || f.name === 'Condição de pagamento'
                                  || f.name === 'Forma de pagamento'
                                  || f.name === 'Observações do orçamento',
                                ).length > 0
                            ) || (
                              data.serviceSubtypeDynamicFields
                                .filter((f) => f.name === 'Valor unitário'
                                  || f.name === 'Valor total'
                                  || f.name === 'Condição de pagamento'
                                  || f.name === 'Forma de pagamento'
                                  || f.name === 'Observações do orçamento',
                                ).length > 0
                            )
                          )
                            && (
                              (data.serviceRequestFields
                                .filter((f) => (f.name === 'Valor unitário' && f.value != null)
                                  || (f.name === 'Observações do orçamento' && f.value != null),
                                ).length > 0)
                              || (data.serviceTypeDynamicFields
                                .filter((f) => (f.name === 'Valor unitário' && f.value != null)
                                  || (f.name === 'Observações do orçamento' && f.value != null),
                                ).length > 0)
                              || (data.serviceSubtypeDynamicFields
                                .filter((f) => (f.name === 'Valor unitário' && f.value != null)
                                  || (f.name === 'Observações do orçamento' && f.value != null),
                                ).length > 0)
                            )
                            && userType === 'COOPERCITRUS'
                            && (
                              <Row className="param-row">
                                <Col span={24}>
                                  <Row
                                    className="field-title-text"
                                    justify="space-between"
                                    gutter={[24, 24]}
                                    style={{ marginBottom: 8 }}
                                  >
                                    <Col>Orçamento</Col>
                                  </Row>
                                </Col>
                              </Row>
                            )}
                          {
                            data?.serviceRequestFields?.length > 0
                            && (
                              data?.serviceName?.toUpperCase() === 'GEOFERT'
                              || data?.serviceName === 'Pós-vendas'
                            )
                            && userType === 'COOPERCITRUS'
                            && (
                              data.serviceRequestFields
                                .filter((f) => f.name === 'Valor unitário'
                                  || f.name === 'Valor total'
                                  || f.name === 'Condição de pagamento'
                                  || f.name === 'Forma de pagamento'
                                  || f.name === 'Observações do orçamento',
                                ).map(
                                  (s) => {
                                    return (
                                      s.value != null && (
                                        <Row justify="space-between" className="param-row">
                                          {(
                                            s.idCode?.includes('OBSERVACOES')
                                            || s.idCode?.includes('OBSERVACAO')
                                            || s.name?.includes('Observações do orçamento')
                                          )
                                            ? (
                                              <Col><p className="item-title">{s.name}:</p></Col>
                                            )
                                            : (
                                              <Col>{s.name}:</Col>
                                            )}
                                          {
                                            s.idCode?.includes('VALOR_UNITARIO') || s.idCode?.includes('VALOR_TOTAL')
                                              ? (
                                                <Col>
                                                  <b>
                                                    {s.value.toString().replaceAll('.', ',')}
                                                  </b>
                                                </Col>
                                              )
                                              : (
                                                (
                                                  s.idCode?.includes('OBSERVACOES')
                                                  || s.idCode?.includes('OBSERVACAO')
                                                  || s.name?.includes('Observações do orçamento')
                                                )
                                                  ? (
                                                    <Row gutter={24} className="inline-field param-row">
                                                      <Col span={24}>
                                                        <Col className="observacaoCol">{s.value}</Col>
                                                      </Col>
                                                    </Row>
                                                  ) : (
                                                    <Col>
                                                      <b>
                                                        {s.value}
                                                      </b>
                                                    </Col>
                                                  )
                                              )
                                          }
                                        </Row>
                                      )
                                    );
                                  },
                                )
                            )
                          }
                          {
                            (
                              data?.serviceName === 'Satélite'
                              || data?.serviceName === 'Vant'
                              || data?.serviceName === 'Aplicação de corretivos'
                              || data?.serviceName === 'Spray Drone'
                            )
                            && userType === 'COOPERCITRUS'
                            && (
                              data.serviceTypeDynamicFields
                                .filter((f) => f.name === 'Valor unitário'
                                  || f.name === 'Valor total'
                                  || f.name === 'Condição de pagamento'
                                  || f.name === 'Forma de pagamento'
                                  || f.name === 'Observações do orçamento',
                                ).map(
                                  (s) => {
                                    return (
                                      s.value != null && (
                                        <Row justify="space-between" className="param-row">
                                          {(
                                            s.idCode?.includes('OBSERVACOES')
                                            || s.idCode?.includes('OBSERVACAO')
                                            || s.name?.includes('Observações do orçamento')
                                          )
                                            ? (
                                              <Col><p className="item-title">{s.name}:</p></Col>
                                            )
                                            : (
                                              <Col>{s.name}:</Col>
                                            )}
                                          {
                                            s.idCode?.includes('VALOR_UNITARIO') || s.idCode?.includes('VALOR_TOTAL')
                                              ? (
                                                <Col>
                                                  <b>
                                                    {s.value.toString().replaceAll('.', ',')}
                                                  </b>
                                                </Col>
                                              )
                                              : ((
                                                s.idCode?.includes('OBSERVACOES')
                                                || s.idCode?.includes('OBSERVACAO')
                                                || s.name?.includes('Observações do orçamento')
                                              )
                                                ? (
                                                  <Row gutter={24} className="inline-field param-row">
                                                    <Col span={24}>
                                                      <Col className="observacaoCol">{s.value}</Col>
                                                    </Col>
                                                  </Row>
                                                ) : (
                                                  <Col>
                                                    <b>
                                                      {s.value}
                                                    </b>
                                                  </Col>
                                                )
                                              )
                                          }
                                        </Row>
                                      )
                                    );
                                  },
                                )
                            )
                          }
                          {
                            (
                              data?.serviceName === 'Satélite'
                              || data?.serviceName === 'Vant'
                              || data?.serviceName === 'Aplicação de corretivos'
                              || data?.serviceName === 'Spray Drone'
                            )
                            && userType === 'COOPERCITRUS'
                            && (
                              data.serviceSubtypeDynamicFields
                                .filter((f) => f.name === 'Valor unitário'
                                  || f.name === 'Valor total'
                                  || f.name === 'Condição de pagamento'
                                  || f.name === 'Forma de pagamento'
                                  || f.name === 'Observações do orçamento',
                                ).map(
                                  (s) => {
                                    return (
                                      s.value != null && (
                                        <Row justify="space-between" className="param-row">
                                          {(
                                            s.idCode?.includes('OBSERVACOES')
                                            || s.idCode?.includes('OBSERVACAO')
                                            || s.name?.includes('Observações do orçamento')
                                          )
                                            ? (
                                              <Col><p className="item-title">{s.name}:</p></Col>
                                            )
                                            : (
                                              <Col>{s.name}:</Col>
                                            )}
                                          {
                                            s.idCode?.includes('VALOR_UNITARIO') || s.idCode?.includes('VALOR_TOTAL')
                                              ? (
                                                <Col>
                                                  <b>
                                                    {s.value.toString().replaceAll('.', ',')}
                                                  </b>
                                                </Col>
                                              )
                                              : ((
                                                s.idCode?.includes('OBSERVACOES')
                                                || s.idCode?.includes('OBSERVACAO')
                                                || s.name?.includes('Observações do orçamento')
                                              )
                                                ? (
                                                  <Row gutter={24} className="inline-field param-row">
                                                    <Col span={24}>
                                                      <Col className="observacaoCol">{s.value}</Col>
                                                    </Col>
                                                  </Row>
                                                ) : (
                                                  <Col>
                                                    <b>
                                                      {s.value}
                                                    </b>
                                                  </Col>
                                                )
                                              )
                                          }
                                        </Row>
                                      )
                                    );
                                  },
                                )
                            )
                          }
                        </div>
                      )
                    }
                    {
                      data?.responsableUserBudgetName != null && userType === 'COOPERCITRUS' && (
                        <div>
                          <Row className="param-row">
                            <p className="item-title">Responsável pelo orçamento:</p>
                          </Row>
                          <Row gutter={24} className="inline-field param-row">
                            <Col span={24}>
                              <Col className="observacaoCol">
                                {
                                  !data?.responsableUserBudgetName
                                    ? '-'
                                    : data?.responsableUserBudgetName
                                }
                              </Col>
                            </Col>
                          </Row>
                        </div>
                      )
                    }
                    <Row gutter={24}>
                      <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                        <p className="item-title">ID da solicitação</p>
                        <p className="item-descripetion">{routeMatch.params.id}</p>
                      </Col>
                      <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                        <p className="item-title">Status</p>
                        <p className="item-descripetion">{data.status}</p>
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                        <p className="item-title">Data/hora da solicitação</p>
                        <p className="item-descripetion">
                          {
                            (data.solicitationDateTime
                              ? moment(data.solicitationDateTime).format('DD/MM/YYYY [às] HH:mm')
                              : '')
                          }
                        </p>
                      </Col>
                      <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                        <p className="item-title">Serviço/tipo de serviço</p>
                        <p className="item-descripetion">
                          {data.serviceName}
                          {data?.serviceTypeName && `: ${data.serviceTypeName}`}
                          {data?.serviceSubtypeName && ` - ${data.serviceSubtypeName}`}
                        </p>
                      </Col>
                    </Row>

                    <Row gutter={24}>
                      <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                        <p className="item-title">Filial</p>
                        <p className="item-descripetion">
                          {data.branchCoopercitrus ? data.branchCoopercitrus.name : '-'}
                        </p>
                      </Col>
                      <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                        <p className="item-title">CTC responsável</p>
                        <p className="item-descripetion">
                          {data.ctc ? data.ctc : '-'}
                        </p>
                      </Col>
                    </Row>

                    <Row gutter={24}>
                      <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                        <p className="item-title">Usuário que solicitou</p>
                        <p className="item-descripetion">{data.userNameThatRequestedTheService}</p>
                      </Col>
                      {
                        userType === 'COOPERCITRUS'
                        && (
                          <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                            <p className="item-title">Usuário responsável</p>
                            <p className="item-descripetion">{data.responsableUserName || '(Nenhum)'}</p>
                          </Col>
                        )
                      }
                      {
                        data.schedulingDate
                        && (
                          <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                            <p className="item-title">Data do agendamento</p>
                            <p className="item-descripetion">
                              {getFormattedscheduleDate(data.schedulingDate)}
                            </p>
                          </Col>
                        )
                      }
                      {
                        data.technicalDateAllocated != '' && data.technicalDateAllocated != null
                        && (
                          <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                            <p className="item-title">Data em que foi aceito</p>
                            <p className="item-descripetion">
                              {moment(data.technicalDateAllocated).format('DD/MM/YYYY [às] HH:mm')}
                            </p>
                          </Col>
                        )
                      }
                    </Row>
                    <Row gutter={24}>
                      <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                        <p className="item-title">Telefone para contato</p>
                        <p className="item-descripetion">
                          {
                            !data.telephone
                              ? ''
                              : formatTelephone(data.telephone)
                          }
                        </p>
                      </Col>
                    </Row>
                    {
                      data.dateRefusal != '' && data.dateRefusal != null
                      && (
                        <Row gutter={24}>
                          <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                            <p className="item-title">Data em que foi recusado</p>
                            <p className="item-descripetion">
                              {moment(data.dateRefusal).format('DD/MM/YYYY [às] HH:mm')}
                            </p>
                          </Col>
                        </Row>
                      )
                    }
                    {
                      data.noteRefusal != '' && data.noteRefusal != null
                      && (
                        <Row gutter={24}>
                          <Col xs={{ span: 12 }} lg={{ span: 12 }}>
                            <p className="item-title">Motivo de recusa</p>
                            <p className="item-descripetion">
                              {data.noteRefusal}
                            </p>
                          </Col>
                        </Row>
                      )
                    }
                    {
                      data.reasonForCancellation
                      && (
                        <Row gutter={24}>
                          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                            <p className="item-title">Motivo do cancelamento</p>
                            <p className="item-descripetion">
                              {data.reasonForCancellation}
                            </p>
                          </Col>
                        </Row>
                      )
                    }

                    <Row className="param-row">
                      <Col>
                        <p className="item-title">Informações adicionais</p>
                        {`Matrícula: ${data.matriculationNumber}`}
                      </Col>
                    </Row>

                    <Row className="param-row">
                      <Col>
                        {`Cooperado: ${data.landOwnerName}`}
                      </Col>
                    </Row>

                    <Row className="param-row">
                      <Col>
                        {data.landName !== null ? `Propriedade: ${data.landName}` : 'Propriedade: -'}
                      </Col>
                    </Row>

                    {
                      data.serviceSubtypeName
                      && (
                        <Row className="param-row">
                          <Col span={24}>
                            <Row justify="space-between">
                              <Col>Tipo:</Col>
                              <Col><b>{data.serviceSubtypeName}</b></Col>
                            </Row>
                          </Col>
                        </Row>
                      )
                    }
                    {
                      isRestructured
                        && data?.serviceRequestFields?.length > 0
                        ? renderRestructuredServiceFields()
                        : null
                    }

                    {
                      !isRestructured
                        ? data.serviceTypeDynamicFields
                          .filter((f) => f.name !== 'Valor unitário'
                            && f.name !== 'Valor total'
                            && f.name !== 'Condição de pagamento'
                            && f.name !== 'Forma de pagamento'
                            && f.name !== 'Observações do orçamento',
                          ).map(
                            (value, index) => renderDynamicFieldSummary(value, `type-${index}`),
                          )
                        : null
                    }
                    {conditionallyRenderGridAndSubtypeFields()}

                    <Row className="param-row">
                      <Col>
                        {
                          data.serviceRequestNotes != []
                            && data.serviceRequestNotes != null
                            && data.serviceRequestNotes.filter((v) => v.type === 'COOPERATIVE').length
                            ? (
                              <div>
                                <p className="item-title">Observação:</p>
                                <Col>
                                  {
                                    data.serviceRequestNotes.map((v) => {
                                      if (v.type === 'COOPERATIVE') {
                                        return (
                                          <Row gutter={24} key={v.id} className="inline-field">
                                            <Col span={24}>
                                              <Col className="observacaoCol">{v.notes}</Col>
                                              <Divider type="horizontal" />
                                            </Col>
                                          </Row>
                                        );
                                      }
                                      return (
                                        <div></div>
                                      );
                                    })
                                  }
                                </Col>
                              </div>
                            ) : (
                              <div></div>
                            )
                        }
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {data.serviceRequestNotes != []
                          && data.serviceRequestNotes != null
                          && data.serviceRequestNotes.filter((v) => v.type === 'COOPERCITRUS').length
                          ? (
                            <div>
                              <p className="item-title">Observações da Coopercitrus:</p>
                              <Col>
                                {
                                  data.serviceRequestNotes.map((v) => {
                                    if (v.type === 'COOPERCITRUS') {
                                      return (
                                        <Row gutter={24} key={v.id} className="inline-field">
                                          <Col span={24}>
                                            <Col className="observacaoCol">{v.notes}</Col>
                                            <Divider type="horizontal" />
                                          </Col>
                                        </Row>
                                      );
                                    }
                                    return (
                                      <div></div>
                                    );
                                  })
                                }
                              </Col>
                            </div>
                          ) : (
                            <div></div>
                          )}
                      </Col>
                    </Row>
                    <Divider type="horizontal" />
                  </div>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12, offset: 1 }} style={{ paddingTop: 15 }}>
                  {
                    (
                      data.serviceName !== 'Pós-vendas'
                        ? (
                          <>
                            <SelectedLands
                              talhoesSelecionados={
                                data.landFields.map((v) => ({
                                  ...v, culture: { description: v.culture },
                                }))
                              }
                            />

                            <AreaTalhao talhoesSelecionados={
                              data.landFields.map((v) => ({
                                ...v, culture: { description: v.culture },
                              }))
                            }
                            />
                          </>
                        )
                        : null
                    )
                  }

                  <div className="attachments-container">
                    <Row className="param-row">
                      <Col span={24}>
                        <Collapse defaultActiveKey={['0']}>
                          <Panel header="Anexos do Cooperado" key="1">
                            <Row className="param-row">
                              <Col span={24}>
                                <Row
                                  justify="end"
                                  className="field-title-text"
                                  style={{ marginBottom: 8 }}
                                  gutter={[24, 24]}
                                >
                                  <span
                                    onClick={downloadAllFiles}
                                    className="download-attachments"
                                    role="button"
                                    requestType="SERVICO"
                                    tabIndex={0}
                                    onKeyDown={(eventt): void => {
                                      if (eventt.key === 'Enter') {
                                        downloadAllFiles();
                                      }
                                    }}
                                  >
                                    Baixar todos os anexos
                                  </span>
                                </Row>
                                <Row
                                  justify="space-between"
                                  style={{ marginBottom: 8 }}
                                  gutter={[24, 24]}
                                >
                                  <Col>
                                    {
                                      data.attachments.length
                                        ? (
                                          <div></div>
                                        ) : (
                                          <div className="attachments-items-container">
                                            Nenhum anexo adicionado
                                          </div>
                                        )
                                    }
                                    <div className="attachments-items-container">
                                      <UploadFiles
                                        ref={uploadFilesReference}
                                        id={routeMatch.params.id}
                                        origin="details"
                                        requestType="SERVICO"
                                        typeUser="SERVICE_REQUEST_CUSTOMER_FILE"
                                        fileSize={attachmentSizeCooperated}
                                        action="edit"
                                        initialFiles={
                                          data.attachments.map((item) => ({ ...item, uid: item.uid, status: 'done' }))
                                        }
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Button
                                    onClick={uploadAtFiles}
                                  >
                                    Confirmar
                                  </Button>
                                </Row>
                              </Col>
                            </Row>
                          </Panel>
                        </Collapse>
                        <Collapse defaultActiveKey={['0']}>
                          <Panel header="Anexos do Coopercitrus" key="1">
                            <Row
                              justify="end"
                              className="field-title-text"
                              style={{ marginBottom: 8 }}
                              gutter={[24, 24]}
                            >
                              {
                                !!data.attachments.length && (
                                  !loadingDownloadAllServiceRequestFiles
                                    ? (
                                      <span
                                        onClick={downloadAllServiceRequestFiles}
                                        className="download-attachments"
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(eventt): void => {
                                          if (eventt.key === 'Enter') {
                                            downloadAllServiceRequestFiles();
                                          }
                                        }}
                                      >
                                        Baixar todos os anexos
                                      </span>
                                    )
                                    : (
                                      <span
                                        className="downloading-attachments"
                                      >
                                        <Spin indicator={<LoadingOutlined className="load-icon" spin />} />
                                        Realizando Download...
                                      </span>
                                    )
                                )
                              }
                            </Row>
                            <Row
                              justify="space-between"
                              style={{ marginBottom: 8 }}
                              gutter={[24, 24]}
                            >
                              <Col>
                                {
                                  data.attachments.length
                                    ? (
                                      <div className="attachments-items-container">
                                        <UploadFiles
                                          requestType="SERVICO"
                                          id={data.id}
                                          action="list"
                                          typeUser="SERVICE_REQUEST_COOPERCITRUS_FILE"
                                          initialFiles={
                                            data.attachments.map((item) => ({ ...item, uid: item.id, status: 'done' }))
                                          }
                                        />
                                      </div>
                                    )
                                    : (
                                      <div className="attachments-items-container">
                                        Nenhum anexo adicionado
                                      </div>
                                    )
                                }
                              </Col>
                            </Row>
                          </Panel>
                        </Collapse>

                        {
                          data.serviceName === 'Pós-vendas'
                            ? (
                              <Collapse defaultActiveKey={['0']}>
                                <Panel header="Anexos de relatório" key="2">
                                  <Row
                                    justify="end"
                                    className="field-title-text"
                                    style={{ marginBottom: 8 }}
                                    gutter={[24, 24]}
                                  >
                                    {
                                      !!data.attachments.length && (
                                        !loadingDownloadAllServiceRequestFiles
                                          ? (
                                            <span
                                              onClick={downloadAllServiceRequestFiles}
                                              className="download-attachments"
                                              role="button"
                                              tabIndex={0}
                                              onKeyDown={(eventt): void => {
                                                if (eventt.key === 'Enter') {
                                                  downloadAllServiceRequestFiles();
                                                }
                                              }}
                                            >
                                              Baixar todos os anexos
                                            </span>
                                          )
                                          : (
                                            <span
                                              className="downloading-attachments"
                                            >
                                              <Spin indicator={<LoadingOutlined className="load-icon" spin />} />
                                              Realizando Download...
                                            </span>
                                          )
                                      )
                                    }
                                  </Row>
                                  <Row
                                    justify="space-between"
                                    style={{ marginBottom: 8 }}
                                    gutter={[24, 24]}
                                  >
                                    <Col>
                                      {
                                        data.attachments.length
                                          ? (
                                            <div className="attachments-items-container">
                                              <UploadFiles
                                                requestType="SERVICO"
                                                id={data.id}
                                                action="list"
                                                typeUser="REPORT_ATTACHMENT"
                                                initialFiles={
                                                  data.attachments.map((item) => ({ ...item, uid: item.id, status: 'done' }))
                                                }
                                              />
                                            </div>
                                          )
                                          : (
                                            <div className="attachments-items-container">
                                              Nenhum anexo adicionado
                                            </div>
                                          )
                                      }
                                    </Col>
                                  </Row>
                                </Panel>
                              </Collapse>
                            )
                            : null
                        }

                      </Col>
                    </Row>
                  </div>
                  {
                    userType === 'COOPERCITRUS' && data.serviceName !== 'Pós-vendas'
                    && (
                      <div className="shapefiles-container">
                        <Row className="param-row">
                          <Col span={24}>
                            <Row
                              className="field-title-text"
                              justify="space-between"
                              gutter={[24, 24]}
                              style={{ marginBottom: 8 }}
                            >
                              <Col>Arquivos geográficos dos talhões</Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row className="param-row">
                          <Col span={24}>
                            <Collapse defaultActiveKey={['0']}>
                              <Panel header="Shapefiles" key="2">
                                <Row
                                  justify="end"
                                  className="field-title-text"
                                  style={{ marginBottom: 8 }}
                                  gutter={[24, 24]}
                                >
                                  <Col>
                                    {
                                      !!data.shapefiles.length && (
                                        !loadingDownloadAllShapeFiles
                                          ? (
                                            <span
                                              onClick={downloadAllShapefiles}
                                              className="download-shapefiles"
                                              role="button"
                                              tabIndex={0}
                                              onKeyDown={(eventt): void => {
                                                if (eventt.key === 'Enter') {
                                                  downloadAllShapefiles();
                                                }
                                              }}
                                            >
                                              Baixar todos os shapefiles
                                            </span>
                                          )
                                          : (
                                            <span
                                              className="downloading-shapefiles"
                                            >
                                              <Spin
                                                indicator={
                                                  <LoadingOutlined className="load-icon" spin />
                                                }
                                              />
                                              Realizando Download...
                                            </span>
                                          )
                                      )
                                    }
                                  </Col>
                                </Row>
                                <Row>
                                  {
                                    data.shapefiles.length
                                      ? (
                                        <div className="shapefiles-items-container">
                                          <UploadFiles
                                            id={data.id}
                                            requestType="SERVICO"
                                            action="list"
                                            initialFiles={
                                              data.shapefiles.map((item) => ({
                                                ...item,
                                                uid: item.id,
                                                status: 'done',
                                                type: 'shapefile',
                                              }))
                                            }
                                          />
                                        </div>
                                      )
                                      : (
                                        <div className="shapefiles-items-container">
                                          Nenhum anexo adicionado
                                        </div>
                                      )
                                  }
                                </Row>
                              </Panel>
                            </Collapse>
                          </Col>
                        </Row>
                        <Row className="param-row">
                          <Col span={24}>
                            <Collapse defaultActiveKey={['0']}>
                              <Panel header="KML" key="3">
                                <Row
                                  justify="end"
                                  className="field-title-text"
                                  style={{ marginBottom: 8 }}
                                  gutter={[24, 24]}
                                >
                                  <Col>
                                    {
                                      !!data.kml.length && (
                                        !loadingDownloadAllKMLFiles
                                          ? (
                                            <span
                                              onClick={downloadAllKML}
                                              className="download-shapefiles"
                                              role="button"
                                              tabIndex={0}
                                              onKeyDown={(eventt): void => {
                                                if (eventt.key === 'Enter') {
                                                  downloadAllKML();
                                                }
                                              }}
                                            >
                                              Baixar todos os Arquivos KML
                                            </span>
                                          )
                                          : (
                                            <span
                                              className="downloading-shapefiles"
                                            >
                                              <Spin
                                                indicator={
                                                  <LoadingOutlined className="load-icon" spin />
                                                }
                                              />
                                              Realizando Download...
                                            </span>
                                          )
                                      )
                                    }
                                  </Col>
                                </Row>
                                <Row>
                                  {
                                    data.kml.length
                                      ? (
                                        <div className="shapefiles-items-container">
                                          <UploadFiles
                                            id={data.id}
                                            requestType="SERVICO"
                                            action="list"
                                            initialFiles={
                                              data.kml.map((item) => ({
                                                ...item,
                                                uid: item.id,
                                                status: 'done',
                                                type: 'kml',
                                              }))
                                            }
                                          />
                                        </div>
                                      )
                                      : (
                                        <div className="shapefiles-items-container">
                                          Nenhum anexo adicionado
                                        </div>
                                      )
                                  }
                                </Row>
                              </Panel>
                            </Collapse>
                          </Col>
                        </Row>
                        <Row className="param-row">
                          <Col span={24}>
                            <Collapse defaultActiveKey={['0']}>
                              <Panel header="KMZ" key="4">
                                <Row
                                  justify="end"
                                  className="field-title-text"
                                  style={{ marginBottom: 8 }}
                                  gutter={[24, 24]}
                                >
                                  <Col>
                                    {
                                      !!data.kmz.length && (
                                        !loadingDownloadAllKMZFiles
                                          ? (
                                            <span
                                              onClick={downloadAllKMZ}
                                              className="download-shapefiles"
                                              role="button"
                                              tabIndex={0}
                                              onKeyDown={(eventt): void => {
                                                if (eventt.key === 'Enter') {
                                                  downloadAllKMZ();
                                                }
                                              }}
                                            >
                                              Baixar todos os KMZ
                                            </span>
                                          )
                                          : (
                                            <span
                                              className="downloading-shapefiles"
                                            >
                                              <Spin
                                                indicator={
                                                  <LoadingOutlined className="load-icon" spin />
                                                }
                                              />
                                              Realizando Download...
                                            </span>
                                          )
                                      )
                                    }
                                  </Col>
                                </Row>
                                <Row>
                                  {
                                    data.kmz.length
                                      ? (
                                        <div className="shapefiles-items-container">
                                          <UploadFiles
                                            id={data.id}
                                            requestType="SERVICO"
                                            action="list"
                                            initialFiles={
                                              data.kmz.map((item) => ({
                                                ...item,
                                                uid: item.id,
                                                status: 'done',
                                                type: 'kmz',
                                              }))
                                            }
                                          />
                                        </div>
                                      )
                                      : (
                                        <div className="shapefiles-items-container">
                                          Nenhum anexo adicionado
                                        </div>
                                      )
                                  }
                                </Row>
                              </Panel>
                            </Collapse>
                          </Col>
                        </Row>
                      </div>
                    )
                  }

                  {
                    invertArrLandsFiles.length && getUserPermissions().includes('Listagem de importação de resultados')
                      ? (
                        <>
                          <Row className="param-row">
                            <Col span={24}>
                              <Row
                                className="title-files-history-results"
                                justify="space-between"
                                gutter={[24, 24]}
                                style={{ marginBottom: 8, marginTop: '28px' }}
                              >
                                <Col>Resultados importados</Col>
                              </Row>
                            </Col>
                          </Row>
                          {
                            invertArrLandsFiles.map((item, indice) => {
                              return (
                                <Row className="param-row">
                                  <Col span={24}>
                                    <Collapse defaultActiveKey={['0']}>
                                      <Panel header={item.name} key={indice + 5}>
                                        <Row
                                          justify="end"
                                          className="field-title-text"
                                          style={{ marginBottom: 8 }}
                                          gutter={[24, 24]}
                                        >
                                          <Col className="allAttachsHistoryResults">
                                            {
                                              invertArrLandsFiles.length
                                                ? (
                                                  <span
                                                    onClick={
                                                      (e): void => {
                                                        downloadAllFiles(e, 'resultados-importados');
                                                      }
                                                    }
                                                    className="download-files itemHistoryResults"
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyDown={(eventt): void => {
                                                      if (eventt.key === 'Enter') {
                                                        downloadAllFiles();
                                                      }
                                                    }}
                                                  >
                                                    Baixar todos os anexos
                                                  </span>
                                                )
                                                : (
                                                  <span
                                                    className="downloading-shapefiles itemHistoryResults"
                                                  >
                                                    <Spin
                                                      indicator={
                                                        <LoadingOutlined className="load-icon" spin />
                                                      }
                                                    />
                                                    Realizando Download...
                                                  </span>
                                                )
                                            }

                                            <Tooltip
                                              className="itemHistoryResults"
                                              title={`Para a funcionalidade de "Baixar todos os anexos", 
                                                    são consideradas todas as importações 
                                                    de resultados vinculadas à propriedade.`}
                                            >
                                              <InfoCircleOutlined className="tooltipInfo" />
                                            </Tooltip>
                                          </Col>
                                        </Row>
                                        <Row>
                                          {/* {
                                                  invertArrLandsFiles.length
                                                    ? (
                                                      <div className="shapefiles-items-container">
                                                        <UploadFiles
                                                          id={item.id}
                                                          action="list"
                                                          initialFiles={
                                                            item.filesAvailable.map((file) => ({
                                                              ...file,
                                                              uid: file.id,
                                                              status: 'done',
                                                              type: file.type,
                                                            }))
                                                          }
                                                        />
                                                      </div>
                                                    )
                                                    : null
                                                } */}

                                          {
                                            invertArrLandsFiles.length
                                              ? (
                                                <>
                                                  {
                                                    item.filesAvailable.map((f) => {
                                                      return (
                                                        <>
                                                          <Tooltip
                                                            placement="topLeft"
                                                            title={`Nome: ${f.name}
                                                                  ${f?.note != null ? 'Observação: ' : ''}
                                                                  ${f?.note != null ? f.note : ''}`}
                                                          >
                                                            <Card
                                                              key={f.id}
                                                              className="file-card"
                                                            >
                                                              <img
                                                                className="selectFile"
                                                                src={getIconByName(f.type)}
                                                                alt="icons file"
                                                              />
                                                              <div
                                                                style={
                                                                  {
                                                                    display: 'flex',
                                                                    alignItems: 'flex-start',
                                                                    justifyContent: 'center',
                                                                    flexDirection: 'column',
                                                                  }
                                                                }
                                                                className="file-title itemsDescription"
                                                              >

                                                                <span className="file-title selectFile firstItem">{f.name}</span>
                                                                <span className="file-title selectFile listItems">{`ID do arquivo: ${f.id}`}</span>
                                                                <span className="file-title selectFile listItems">
                                                                  {
                                                                    `Data: ${moment(f.registrationDate)
                                                                      .startOf('day')
                                                                      .format('DD/MM/YYYY')
                                                                    }`
                                                                  }
                                                                </span>
                                                              </div>
                                                              <span className="downloadIcon iconItem">
                                                                <DownloadOutlined
                                                                  onClick={
                                                                    (): void => {
                                                                      downloadFileLocal(
                                                                        f,
                                                                        null,
                                                                        null,
                                                                      );
                                                                    }
                                                                  }
                                                                />
                                                              </span>
                                                            </Card>
                                                          </Tooltip>
                                                        </>
                                                      );
                                                    })
                                                  }
                                                </>
                                              )
                                              : null
                                          }
                                        </Row>
                                      </Panel>
                                    </Collapse>
                                  </Col>
                                </Row>
                              );
                            })
                          }
                        </>
                      )
                      : null
                  }
                </Col>
              </Row>
            </div>

            <Modal
              wrapClassName="ServiceDetail-status-modal"
              width={1000}
              title={<h3 style={{ margin: 0 }}>Status da solicitação</h3>}
              visible={visibleModalStatus}
              onCancel={
                (): void => {
                  setVisibleModalStatus(false);
                }
              }
              footer={[]}
            >
              {
                visibleModalStatus
                && (
                  <ServiceStatusComponent
                    loading={false}
                    statusesList={statusesList}
                    currentStatusIndex={currentStatusIndex}
                    canceled={canceled}
                  />
                )
              }
            </Modal>
          </Tabs.TabPane>

          {
            userType === 'COOPERCITRUS'
              && data?.serviceName !== 'Pós-vendas'
              && ((getUserPermissions() || []).includes('Importação de arquivos de resultados'))
              ? (
                <Tabs.TabPane
                  tab={(
                    <Typography.Title
                      level={5}
                      className="ServiceDetail__ImportResultsTabTitle"
                    >
                      Importar resultados
                    </Typography.Title>
                  )}
                  key="2"
                >
                  <div className="ServiceDetail__ImportResultsContent">
                    <Row
                      gutter={24}
                    >
                      <Col
                        span={24}
                      >
                        <Form
                          form={importResultFormInstance}
                          layout="vertical"
                          onFinish={
                            (importResultFormInstanceValues): void => {
                              setRequestNewInstance(true);
                              setVisibleModalImportResult(true);
                            }
                          }
                          onFinishFailed={
                            (errorInfo): void => {
                              console.log('import file form error', errorInfo);
                              notification.error({
                                description: errorInfo?.errorFields?.[0]?.errors?.[0],
                              });
                            }
                          }
                        >
                          <Form.Item
                            name="resultFile"
                            getValueFromEvent={normFile}
                            valuePropName="fileList"
                            rules={[
                              {
                                validator: (rule, value): Promise<any> => {
                                  if (!value.length) {
                                    return Promise.resolve();
                                  }

                                  const allowedExtensions = [
                                    'pdf', 'doc', 'docx', 'csv', 'rar', 'zip',
                                    'kml', 'KML', 'kmz', 'KMZ',
                                  ];

                                  let typeError = false;
                                  let extension = value[0].name.split('.');
                                  extension = extension[extension.length - 1];

                                  if (allowedExtensions.includes(extension) === false) {
                                    typeError = true;
                                  }

                                  /*
                                    os arquivos enviados pelo windows nao estao
                                    apresentando o mime type correto, gerando
                                    falhas para os arquivos doc, docx, kml, kmz.
                                    Portando a checagem por tipo foi desabilitada.
                                  */
                                  // if (allowedTypes.includes(fileType) === false) {
                                  //   typeError = true;
                                  //   console.log('tipo do arquivo nao permitido');
                                  // }

                                  if (typeError) {
                                    const msgError = `Tipo de arquivo invalido. As extensões 
                                    permitidas são: .pdf, .doc, .docx, .csv, .rar, .zip, 
                                    .kml e .kmz`;

                                    resetSelectedReferenceLandField();
                                    importResultFormInstance.resetFields();
                                    importResultModalFormInstance.resetFields();
                                    setVisibleModalImportResult(false);
                                    return Promise.reject(new Error(msgError));
                                  }

                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <Upload
                              name="resultFile"
                              listType="picture-card"
                              className="ServiceDetail__AddResultsInput"
                              beforeUpload={
                                (): false => {
                                  // override default upload and do it manually
                                  return false;
                                }
                              }
                              onChange={
                                (): void => {
                                  importResultFormInstance.submit();
                                }
                              }
                              maxCount={1}
                            >
                              <Button
                                icon={<PlusOutlined />}
                                type="link"
                                className="ServiceDetail__AddResultsButton"
                                block
                              >
                                Adicionar resultados
                              </Button>
                            </Upload >
                          </Form.Item >
                        </Form >
                      </Col >
                    </Row >
                  </div >

                  <div className="ServiceDetail__ImportResultsContent">
                    <div>
                      <b style={{ fontSize: '16px' }}>Resultados importados</b>
                    </div>

                    {
                      listImportResult.length > 0
                        ? listImportResult.map((i, indice) => {
                          return (
                            <Row key={i.id} gutter={24} style={{ marginTop: '1rem' }}>
                              <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 4 }}>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    justifyContent: 'start',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <span className="ant-form-item-greencooper">Data de importação:</span>
                                  <span style={{ fontSize: '.85rem', wordBreak: 'break-all' }}>{moment(i.registrationDate).format('DD/MM/YYYY')}</span>
                                </div>
                              </Col>

                              <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 4 }}>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    justifyContent: 'start',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <span className="ant-form-item-greencooper">Tipo de arquivo:</span>
                                  <span style={{ fontStyle: 'italic', fontSize: '.85rem', wordBreak: 'break-all' }}>{i.type}</span>
                                </div>
                              </Col>

                              <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }}>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    justifyContent: 'start',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <span className="ant-form-item-greencooper">Nome do arquivo:</span>
                                  <p
                                    className="truncate-text"
                                    style={{
                                      fontStyle: 'italic',
                                      fontSize: '.85rem',
                                      wordBreak: 'break-all',
                                    }}
                                  >
                                    <Tooltip
                                      placement="topLeft"
                                      title={i.name}
                                    >
                                      <span>
                                        {i.name.replace(/(.*)\.[^.]+$/, '$1')}
                                      </span>
                                    </Tooltip>
                                  </p>
                                </div>
                              </Col>

                              <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    justifyContent: 'start',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <span className="ant-form-item-greencooper">Talhões relacionados:</span>
                                  <p
                                    className="truncate-text"
                                    style={{
                                      fontStyle: 'italic',
                                      fontSize: '.85rem',
                                      wordBreak: 'break-all',
                                    }}
                                  >
                                    <Tooltip
                                      placement="topLeft"
                                      title={i.namesLandFields}
                                    >
                                      <span>
                                        {i.namesLandFields ? i.namesLandFields : '-'}
                                      </span>
                                    </Tooltip>
                                  </p>
                                </div>
                              </Col>

                              <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 2 }}>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    justifyContent: 'flex-start',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <span className="ant-form-item-greencooper">Ações:</span>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-start',
                                      flexDirection: 'row',
                                    }}
                                  >
                                    <Button
                                      icon={<DownloadOutlined />}
                                      className="btn-action"
                                      onClick={(): void => {
                                        handleDownloadFileImportResult(i.id, i.name);
                                      }}
                                    />
                                    {
                                      ((getUserPermissions() || []).includes('Edição importação de resultados')) && (
                                        <Button
                                          icon={<EditOutlined />}
                                          className="btn-action"
                                          onClick={(): void => handleUpdateFileImportResult(i.id, indice)}
                                        />
                                      )
                                    }
                                    {
                                      ((getUserPermissions() || []).includes('Delete importação de resultados')) && (
                                        <Button
                                          icon={<DeleteOutlined />}
                                          className="btn-action"
                                          onClick={(): void => confirmDeleteFileImportResult(i.id)}
                                        />
                                      )
                                    }
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          );
                        })
                        : (
                          <div style={{ marginBottom: '.7rem' }}>
                            <span style={{ fontStyle: 'italic' }}>Nenhum anexo adicionado.</span>
                          </div>
                        )
                    }
                  </div>

                  <Modal
                    visible={visibleModalImportResult}
                    destroyOnClose
                    closable={false}
                    okText="Importar arquivo"
                    okButtonProps={{
                      loading: uploadFileLoading || associateFileLoading,
                      disabled: selectedReferenceFields.length === 0,
                    }}
                    onOk={
                      (): void => {
                        importResultModalFormInstance.submit();
                      }
                    }
                    cancelButtonProps={{
                      loading: uploadFileLoading || associateFileLoading,
                    }}
                    onCancel={
                      (): void => {
                        resetSelectedReferenceLandField();
                        importResultFormInstance.resetFields();
                        importResultModalFormInstance.resetFields();
                        setVisibleModalImportResult(false);
                      }
                    }
                    destroyOnClose={true}
                  >
                    <Form
                      form={importResultModalFormInstance}
                      onFinish={handleSuccessfulFormImportFile}
                      onFinishFailed={
                        (errorInfo): void => {
                          console.log('service detail import result modal finish failed', errorInfo);
                        }
                      }
                      layout="vertical"
                    >
                      <div>
                        <Row
                          gutter={24}
                        >
                          <Col
                            xs={{ span: 24 }}
                          >
                            <Typography.Text
                              className="ServiceDetail__SelectLandFieldModal"
                            >
                              Selecione quais talhões este arquivo se refere.
                            </Typography.Text>
                            <Row
                              gutter={24}
                              className="ServiceDetail__LandFieldModalRow"
                            >

                              <Col
                                xs={{ span: 8 }}
                              >
                                <Form.Item
                                  label="Talhões"
                                  validateStatus={selectedReferenceFields.length === 0 ? 'error' : ''}
                                  help={selectedReferenceFields.length === 0 ? 'Por favor selecione ao menos um talhão.' : ''}
                                >
                                  <List
                                    itemLayout="vertical"
                                    className="ServiceDetail__LandFieldsList"
                                    dataSource={data.landFields}
                                    renderItem={
                                      (item): JSX.Element => {
                                        return (
                                          <List.Item>

                                            {
                                              requestNewInstance === true
                                                ? (
                                                  <Checkbox
                                                    value={item.id}
                                                    onChange={
                                                      (eventt): void => {
                                                        handleChangeReferenceLandField(eventt);
                                                      }
                                                    }
                                                  >
                                                    {item.name}
                                                  </Checkbox>
                                                )
                                                : (
                                                  <Checkbox
                                                    defaultChecked={resolveLand(item.id)}
                                                    value={item.id}
                                                    onChange={
                                                      (eventt): void => {
                                                        handleChangeReferenceLandField(eventt);
                                                      }
                                                    }
                                                  >
                                                    {item.name}
                                                  </Checkbox>
                                                )
                                            }

                                          </List.Item>
                                        );
                                      }
                                    }
                                  />
                                </Form.Item>
                              </Col>

                              <Col
                                xs={{ span: 16 }}
                              >
                                <Form.Item
                                  label="Observações"
                                  name="comments"
                                >
                                  <Input.TextArea />
                                </Form.Item>
                              </Col>
                            </Row>

                          </Col>
                        </Row>
                      </div>
                    </Form>
                  </Modal>
                </Tabs.TabPane >
              )
              : null
          }
        </Tabs >
      </Spin >
    </div>
  );
};

ServiceDetail.propTypes = {};
ServiceDetail.defaultProps = {};

export default ServiceDetail;
